module.exports = __webpack_public_path__ + "static/media/background.ed7817f7.svg";